/* eslint-disable no-unused-vars */
import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const getBrandByBrandKey = brandKey => firestore.collection('brands').doc(brandKey).get().then((brandSnap) => {
	if (!brandSnap.exists) {
		return Promise.reject(errorOfType(errorTypes.NOTFOUND, { brandKey }))
	}
	const brand = brandSnap.data()
	if (brand.deleted) {
		return Promise.reject(errorOfType(errorTypes.NOTFOUND, { brandKey, reason: 'deleted' }))
	}

	return Promise.resolve({ brand })
}).catch(exception => Promise.reject(errorOfType(errorTypes.UNKNOWNERROR, brandKey, exception)))

export default getBrandByBrandKey



// WEBPACK FOOTER //
// ./src/dataservices/getBrandByBrandKey.js